export default __webpack_public_path__ + "static/media/advc.88de7602.svg";